import React from "react";
import { type RadioProps, SupRadio } from "@repo/core-ui";
import { useFormContext } from "react-hook-form";

export interface RadioFieldProps extends RadioProps {
  name: string;
  value: string;
}

export function SupRadioField({ name, id = name, label, className, disabled, value, defaultChecked, labelClassName, orientation }: RadioFieldProps) {
  const { register } = useFormContext();
  const { name: inputName, ref, onChange, onBlur } = register(name);

  return (
    <SupRadio
      ref={ref}
      name={inputName}
      id={id}
      label={label}
      className={className}
      disabled={disabled}
      value={value}
      defaultChecked={defaultChecked}
      labelClassName={labelClassName}
      orientation={orientation}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      inputProps={{ onChange, onBlur }}
    />
  );
}
